<h1 id="title" class="title">Guardian Verification</h1>
<p class="sub-title">Please provide guardian email to continue</p>

<!-- ERROR MESSAGE -->
<nb-alert *ngIf="errors.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>Oh snap!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<!-- SUCCESS MESSAGE -->
<nb-alert *ngIf="messages.length && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>Success</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let msg of messages" class="alert-message">{{ msg }}</li>
  </ul>
</nb-alert>

<!-- STEP 1: GUARDIAN EMAIL -->
<form *ngIf="step === 'guardianEmail'" [formGroup]="guardianForm" aria-labelledby="title">

  <div class="form-control-group">
    <label class="label" for="guardianEmail">Guardian Email:</label>

    <input nbInput
           id="guardianEmail"
           fullWidth
           fieldSize="large"
           type="email"
           formControlName="guardianEmail"
           placeholder="Enter guardian email"
           [status]="guardianForm.get('guardianEmail')?.dirty
              ? (guardianForm.get('guardianEmail')?.invalid ? 'danger' : 'success')
              : 'basic'">

    <ng-container *ngIf="guardianForm.get('guardianEmail')?.touched">
      <p class="caption status-danger" *ngIf="guardianForm.get('guardianEmail')?.errors?.required">
        Guardian email is required!
      </p>
      <p class="caption status-danger" *ngIf="guardianForm.get('guardianEmail')?.errors?.email">
        Enter a valid email address.
      </p>
    </ng-container>

  </div>

  <button nbButton
          status="primary"
          fullWidth
          size="large"
          [disabled]="guardianForm.invalid || loading"
          (click)="sendGuardianOtp()"
          [class.btn-pulse]="loading">
    {{ loading ? 'Sending...' : 'Send OTP' }}
  </button>
</form>



<!-- STEP 2: OTP VERIFICATION -->
<form *ngIf="step === 'verifyGuardianOtp'" [formGroup]="otpForm" aria-labelledby="title">

  <p class="sub-title">OTP sent to: <b>{{ email }}</b></p>

  <div class="form-control-group">
    <label class="label" for="otp">Enter OTP:</label>

    <input nbInput
           id="otp"
           fullWidth
           fieldSize="large"
           type="text"
           formControlName="otp"
           placeholder="Enter verification code"
           [status]="otpForm.get('otp')?.dirty
              ? (otpForm.get('otp')?.invalid ? 'danger' : 'success')
              : 'basic'">

    <ng-container *ngIf="otpForm.get('otp')?.touched">
      <p class="caption status-danger" *ngIf="otpForm.get('otp')?.errors?.required">
        OTP is required!
      </p>
    </ng-container>
  </div>

  <button nbButton
          status="success"
          fullWidth
          size="large"
          [disabled]="otpForm.invalid || loading"
          (click)="verifyGuardianOtp()"
          [class.btn-pulse]="loading">
    {{ loading ? 'Verifying...' : 'Verify OTP' }}
  </button>

  <button nbButton
          status="basic"
          fullWidth
          size="large"
          class="mt-2"
          (click)="step='guardianEmail'">
    Change Email
  </button>

</form>
